import { useEffect } from 'react';
import { Error } from '@lana-ui/login';
import CredencialError from '@images/credencialError';
import PhonesBanner from '../Components/Common/banner/PhonesBanner';
import { PageViewTrackAndLogData } from '../Config/TrackAndLogData';
import UrlHelper from '../Helpers/Url';
import { addGlobalContext } from '../Helpers/DataDog'

const PagoPendiente = ({state}) => {
    useEffect(() => {
        PageViewTrackAndLogData('saldo_pendiente');
        addGlobalContext(state.context, 'Falta de pago');
    }, []);

    return (
        <>
            <Error
                title={
                    <>
                        Tenés un saldo pendiente con <span className="ln">LA NACION</span>
                    </>
                }
                text={
                    <>
                        Para seguir disfrutando de nuestro contenido online, gestioná tu pago pendiente en <span className="ln">Mi Cuenta</span>.
                    </>
                }
                firstButtonLabel="Pagar"
                firstButtonOnClick={() => UrlHelper.RedirectToPendingPayment()}
                secondButtonLabel="Volver"
                secondButtonOnClick={() => (location.href = process.env.REACT_APP_LNREDIRECT)}
                imageUrl={<CredencialError width="201.24" height="160" />}
            />
            <PhonesBanner notSuscribe />
        </>
    );
};

export default PagoPendiente;
